import {
  galateaStarterPack,
  galateaStarterPackLarge,
  pointsLargeAbandonedCart,
  pointsLargeCountdownDoublePointsOffer,
  pointsLargeUpsell,
  pointsMediumUpsell,
  pointsLargeBogoPointsOffer,
} from './non-default.bundles';
import {
  defaultPointsGalateaBigPack,
  defaultPointsGalateaBiggerPack,
  defaultPointsGalateaMediumPack,
  defaultPointsGalateaSmallPack,
  discountedPointsLG,
  discountedPointsMD,
  discountedPointsSM,
  discountedPointsXL,
  discountedPointsXXL,
  discountedPointsXXXL,
  goldenHourPointsSM,
  points110GalateaFor1299,
  points110GalateaFor799,
  points1500GalateaFor3999,
  points1500GalateaFor5999,
  points250GalateaFor1399,
  points250GalateaFor2499,
  points3000GalateaFor6999,
  points3000GalateaFor9999,
  points40GalateaFor399,
  points40GalateaFor799,
  points550GalateaFor2499,
  points550GalateaFor3999,
  pointsLGHigher1,
  pointsLGLower1,
  pointsMDHigher1,
  pointsMDLower1,
  pointsSMHigher1,
  pointsSMLower1,
  pointsXLHigher1,
  pointsXLLower1,
} from './points.bundles';

export const allPointsBundle = [
  defaultPointsGalateaSmallPack,
  defaultPointsGalateaMediumPack,
  defaultPointsGalateaBigPack,
  defaultPointsGalateaBiggerPack,
  points40GalateaFor399,
  points110GalateaFor799,
  points250GalateaFor1399,
  points550GalateaFor2499,
  points40GalateaFor799,
  points110GalateaFor1299,
  points250GalateaFor2499,
  points550GalateaFor3999,
  points1500GalateaFor3999,
  points3000GalateaFor6999,
  points1500GalateaFor5999,
  points3000GalateaFor9999,
  pointsSMHigher1,
  pointsMDHigher1,
  pointsLGHigher1,
  pointsXLHigher1,
  pointsSMLower1,
  pointsMDLower1,
  pointsLGLower1,
  pointsXLLower1,

  // Upsell products
  pointsMediumUpsell,
  pointsLargeUpsell,

  // cart abandonment products
  pointsLargeAbandonedCart,

  // Countdown Double Points Offer
  pointsLargeCountdownDoublePointsOffer,

  // Discounted points products
  discountedPointsSM,
  discountedPointsMD,
  discountedPointsLG,
  discountedPointsXL,
  discountedPointsXXL,
  discountedPointsXXXL,

  // Starter pack products
  galateaStarterPack,
  galateaStarterPackLarge,

  // Stripe Only points offer
  pointsLargeBogoPointsOffer,

  // Golden Hour points products
  goldenHourPointsSM,
];
